import React, { useState } from "react";
import { Collapse, Icon } from "antd";
import { CollapseProps } from "antd/es/collapse";
import classNames from "classnames";
import CoursewareItem from "../../../CoursewareItem";
import styles from "./index.module.scss";
import { SourceItem } from "../../../../../../../../../ResourcePool/service";
import { ChapterTree } from "../../../../../../../../../../service/CourseDetail/chapter";
const Panel = Collapse.Panel;

interface ChapterNodeProps extends CollapseProps {
    title: React.ReactNode;
    indent?: number;
    chapters: ChapterTree[];
    sources: SourceItem[];
}

export default function ChapterNode({
    title,
    chapters,
    sources,
    className,
    indent = 0
}: ChapterNodeProps) {
    const [key] = useState(Math.random());
    const [collapse, setCollapse] = useState<boolean>(false);

    return (
        <Collapse
            className={classNames(className, styles[`indent${indent}`])}
            defaultActiveKey={key}
            expandIcon={() => (
                <Icon
                    type={collapse ? "caret-right" : "caret-down"}
                    style={{ color: "#bbb" }}
                />
            )}
            onChange={keys => setCollapse(keys.length === 0)}>
            <Panel header={title} key={key}>
                {chapters.map(item => (
                    <ChapterNode
                        key={item.id}
                        title={item.chapterName}
                        indent={item.level}
                        chapters={item.children || []}
                        sources={item.dcCoursewareSourceList || []}
                    />
                ))}

                {sources
                    .filter(item => item.isPublish === 1)
                    .map(item => (
                        <CoursewareItem
                            key={item.id}
                            data={item}
                            indent={indent}
                        />
                    ))}
            </Panel>
        </Collapse>
    );
}
